import React from "react";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import SpaceErrorPage from "./components/SpaceErrorPage";

/**
 * Componente puente que extrae el código de la URL.
 * Traefik envía rutas tipo /502.html → extraemos "502"
 */
// 1. Separamos tu lógica original para usarla SOLO en desarrollo local
function ErrorManagerLocal() {
  const { codigoError } = useParams();
  const statusLimpio = codigoError
    ? codigoError.replace(".html", "").replace(".htm", "")
    : "500";
  return <SpaceErrorPage status={statusLimpio} />;
}

export default function App() {
  // 🔥 LA MAGIA: Buscamos la variable que inyecta Nginx en el clúster
  const codigoErrorNginx = window.SERVER_ERROR_CODE;

  // Si la variable existe (estamos en producción detrás de Traefik):
  // Ignoramos completamente las rutas y mostramos el error exacto.
  if (codigoErrorNginx) {
    return <SpaceErrorPage status={codigoErrorNginx} />;
  }

  // Si NO existe (estás probando en tu PC con npm start y localhost:3000):
  // Usamos tu React Router de siempre para que puedas navegar a /502.html a mano.
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:codigoError" element={<ErrorManagerLocal />} />
        <Route path="/" element={<SpaceErrorPage status="404" />} />
        <Route path="*" element={<SpaceErrorPage status="404" />} />
      </Routes>
    </BrowserRouter>
  );
}